import { VideoUploader, withS3ServiceRequestConvertor, withUploadModule } from '@vzmi/shp_shared_compo'
import { connect } from 'react-redux'
import { compose, bindActionCreators } from 'redux'
import {
  fetchS3Wssid,
  fetchS3Object,
  fetchTempCredential
} from '../../../actions/serviceActions/common'

const mapDispatchToProps = dispatch => {
  return {
    s3Service: bindActionCreators(
      {
        fetchS3Object,
        fetchS3Wssid,
        fetchTempCredential
      },
      dispatch
    )
  }
}

const enhance = compose(
  connect(null, mapDispatchToProps),
  withS3ServiceRequestConvertor,
  withUploadModule
)

const BoundS3VideoUploader = enhance(VideoUploader)

export default BoundS3VideoUploader
